<template>
  <div class="app-container">
    <BjDivider right-fixed
      >{{ $t('IndexSynchronization.add.Basic') }}
      <template slot="right">
        <el-button @click="tryCancel">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="submit('form')">{{ $t('saveText') }}</el-button>
      </template>
    </BjDivider>

    <el-form ref="form" :model="form" :rules="rules" inline label-width="140px">
      <el-form-item :label="$t('IndexSynchronization.Code')" prop="syncConfCode">
        <BjInput v-model="form.syncConfCode" :maxlength="MAX_LENGTH.DEFAULT" placeholder="" />
      </el-form-item>
      <el-form-item :label="$t('IndexSynchronization.Index')" prop="indexCode">
        <bj-code-select @change="changeIndexCode" />
      </el-form-item>
      <el-form-item :label="$t('IndexSynchronization.Description')" prop="remark">
        <BjInput v-model="form.remark" :maxlength="MAX_LENGTH.DEFAULT" placeholder="" />
      </el-form-item>
      <el-form-item :label="$t('IndexSynchronization.type')" prop="sourceFromType">
        <el-select v-model="form.sourceFromType" class="full-width" :placeholder="$t('chooseText')" clearable>
          <!-- 暂时写死 -->
          <el-option label="INTERFACE" value="INTERFACE" />
          <el-option label="DB" value="DB" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('IndexSynchronization.Data')" prop="sourceFromCode">
        <BjInput v-model="form.sourceFromCode" :maxlength="MAX_LENGTH.DEFAULT" placeholder="" />
      </el-form-item>
      <el-form-item :label="$t('IndexSynchronization.add.Data')" prop="sourceFromDetailCode">
        <BjInput
          v-model="form.sourceFromDetailCode"
          :maxlength="MAX_LENGTH.DEFAULT"
          placeholder=""
        />
      </el-form-item>
      <el-form-item :label="$t('IndexSynchronization.add.Whether')" prop="isRecord">
        <el-switch v-model="form.isRecord" :active-value="1" :inactive-value="0" />
      </el-form-item>
      <el-row>
        <el-col :span="24">
          <el-form-item :label="$t('IndexSynchronization.add.Command')" prop="commandContent">
            <BjInput
              v-model="form.commandContent"
              :maxlength="MAX_LENGTH.DEFAULT"
              type="textarea"
              style="width: 600px"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <BjDivider
      >{{ $t('IndexSynchronization.add.field') }}
      <template slot="button">
        <el-button type="primary" @click="onAdd">{{ $t('addText') }}</el-button>
      </template>
    </BjDivider>
    <el-table border :data="form.indexFieldSyncConfList">
      <el-table-column :label="$t('IndexSynchronization.add.name')" align="center" prop="fieldName">
        <template slot-scope="scope">
          <BjInput
            v-model="scope.row.fieldName"
            :maxlength="MAX_LENGTH.DEFAULT"
            :placeholder="$t('inputText')"
          />
        </template>
      </el-table-column>
      <el-table-column :label="$t('IndexSynchronization.add.Mapping')" align="center" prop="fieldMapping">
        <template slot-scope="scope">
          <!-- <BjInput :maxlength="MAX_LENGTH.DEFAULT"    v-model="scope.row.fieldMapping"  :placeholder="$t('inputText')" /> -->
          <el-select
            v-model="scope.row.fieldMapping"
            filterable
            remote
            reserve-keyword
            :placeholder="$t('inputText')"
            :remote-method="remoteMethodFieldName"
            :loading="loading"
            @change="changeFieldName"
            @focus="changeFocus($event, scope)"
          >
            <el-option
              v-for="item in fieldNameListOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column :label="$t('IndexSynchronization.add.Operation')" align="center">
        <template slot-scope="scope">
          <el-button type="text" icon="el-icon-delete" @click="onDelete(scope.$index)"
            >{{ $t('delText') }}</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="mt20" style="text-align: right">
      <el-pagination
        :current-page="form.pageNun"
        :page-sizes="PAGE_SIZES"
        :page-size="form.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="form.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import viewMiXin from '@/utils/view-mixin.js';
import { settingApi } from '@/api';
import { PAGE_SIZES } from '@/utils/constants';
import BjCodeSelect from '../../components/BjCodeSelect';
export default {
  components: {
    BjCodeSelect,
  },
  mixins: [viewMiXin],
  data() {
    return {
      PAGE_SIZES,
      data: [],
      form: {
        indexFieldSyncConfList: [],
        pageNun: 1,
        pageSize: 15,
        total: 0,
      },
      rules: {
        syncConfCode: [{ required: true, message: this.$t('IndexSynchronization.add.code'), trigger: 'blur' }],
        indexCode: [{ required: true, message: this.$t('IndexSynchronization.add.index'), trigger: 'change' }],
        sourceFromCode: [{ required: true, message: this.$t('IndexSynchronization.add.datasource'), trigger: 'blur' }],
        sourceFromType: [{ required: true, message: this.$t('IndexSynchronization.add.type'), trigger: 'change' }],
      },
      loading: false,
      /** 模糊查询映射列表 */
      fieldNameList: [],
      /** 模糊查询映射匹配列表 */
      fieldNameListOptions: [],
      fieldNameIndex: null,
    };
  },
  computed: {},
  created() {
    if (this.$route.query.syncConfId) {
      settingApi.getIndexesSyncConfigs({ syncConfId: this.$route.query.syncConfId }).then(res => {
        this.form = res;
      });
    }
  },
  mounted() {},
  methods: {
    changeIndexCode(data) {
      this.form.indexCode = data.indexCode;
      this.form.indexId = data.indexId;
      settingApi.getIndexesDetail({ indexId: this.form.indexId }).then(res => {
        res.forEach(item => {
          this.fieldNameList.push({
            value: item.indexFieldId,
            label: item.fieldName,
          });
        });
      });
    },
    remoteMethodFieldName(query) {
      if (query !== '') {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.fieldNameListOptions = this.fieldNameList.filter(item => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.fieldNameListOptions = [];
      }
    },
    changeFieldName(val) {
      const obj = this.fieldNameListOptions.find(item => {
        return item.value === val;
      });
      const form = this.form.indexFieldSyncConfList[this.fieldNameIndex];
      form.fieldMapping = obj.label;
      form.indexFieldId = obj.value;
    },
    /** 映射聚焦时判断 */
    changeFocus(e, scope) {
      if (!this.form.indexCode) {
        this.$alert(this.$t('IndexSynchronization.add.obtain'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          callback: action => {},
        });
        e.target.blur();
        return;
      }
      this.fieldNameIndex = scope.$index;
    },
    handleSizeChange(val) {
    },
    handleCurrentChange(val) {
    },
    onAdd() {
      const obj = {
        fieldName: null,
        fieldMapping: null,
      };
      this.form.indexFieldSyncConfList.push(obj);
    },
    onDelete(index) {
      this.form.indexFieldSyncConfList.splice(index, 1);
    },
    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) return this.$scrollToFormError();
        const boolean = this.form.indexFieldSyncConfList.every(
          item => item.fieldName && item.fieldMapping,
        );
        if (!boolean || this.form.indexFieldSyncConfList.length === 0) {
          this.$alert(this.$t('IndexSynchronization.add.information'), this.$t('toast.hintText'), {
            confirmButtonText: this.$t('toast.okText'),
            callback: action => {},
          });
          return;
        }
        settingApi.AddIndexesSync(this.form).then(res => {
          if (!res.failed) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.complete('SettingIndexesSyncIndex');
            }, 500);
          }
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
